import {IAgreementParser, IAgreementParserFactory} from './agreementParser';
import AllParagraphsParser from './AllParagraphParser';

export const agreementTypes: {
	[key: string]: {
		hasTitle: boolean
	}
} = {
	'': {
		hasTitle: false
	}
};

export class AgreementParserFactory implements IAgreementParserFactory {
	public static $inject: string[] = ['MyAccountApiBasePath'];

	private readonly $: JQueryStatic;
	private readonly baseUrl: string;

	constructor(baseUrl: string) {
		this.$ = $;
		this.baseUrl = baseUrl;
	}

	public getParser(source: string): IAgreementParser {
		return new AllParagraphsParser(this.$, this.baseUrl);
	}
}
